import React from "react";
import {Alert, Form, Input, Button, Row, Col, Select} from "antd";
import get from "lodash/get";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router";

import { delegationLogTestTemplateRequest } from "../../api/requests";

import { logout } from "../../reducers/user/actions";
import classes from "./DelegationLogs.css";

class TestTemplateForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          let data = null;
          const response = await delegationLogTestTemplateRequest(values.type, values.query);
          data = response.data;

          const blob = new Blob([data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.click();

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          if (this.props.onSubmit) {
            this.props.onSubmit();
          }
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: JSON.stringify(get(e, "response.data.error", "Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t(
              "NamespaceDelegationLogs:Test template"
            )}
          </h4>

          <Row gutter={12}>
            <Col md={12}>
              <label>
                <b>{this.props.i18n.t("Template Type")}</b>
                <Form.Item>
                  {getFieldDecorator("type", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Select
                      placeholder={this.props.i18n.t("Select Template Type")}
                      style={{ width: "100%" }}
                      allowClear
                    >
                      <Select.Option value="long">{this.props.i18n.t("Long")}</Select.Option>
                      <Select.Option value="short">{this.props.i18n.t("Short")}</Select.Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>

            <Col md={24}>
              <label>
                <b>{this.props.i18n.t("Query")}</b>
                <p><i><b>Ex:</b> count_staff=35&count_tasks=15&count_role=15&task_len_name=4&role_len_name=3&empty=false</i></p>
                <Form.Item>
                  {getFieldDecorator("query", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Input
                      placeholder={this.props.i18n.t("count_staff=59&count_tasks=26&count_role=25&task_len_name=4&role_len_name=4&empty=false")}
                      style={{ width: "100%" }}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              className={classes.submitButton}
            >
              {this.props.i18n.t("Test Template")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "TestTemplateForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withNamespaces()(TestTemplateForm)))
);



// WEBPACK FOOTER //
// ./src/containers/DelegationLogs/TestTemplateForm.js